import React from "react";
import "../styles/global.css";

function ContactUs() {
  return (
    <div className="contact-page">
      <h1>Contact Us</h1>
      
      <div className="contact-wrapper">
        {/* Left: Contact Info */}
        <div className="contact-info">
          <h2>The Tasty Dine</h2>
          <p>Email: info@thetastydine.com</p>
          <p>Phone: +91 9876543210</p>
          <p>Address: 123 Main Street, Karnataka, India</p>
        </div>

        {/* Right: Contact Form */}
        <form className="contact-form">
          <label>
            Name:
            <input type="text" placeholder="Your name" required />
          </label>
          <label>
            Email:
            <input type="email" placeholder="you@example.com" required />
          </label>
          <label>
            Message:
            <textarea placeholder="Write your message..." rows="5" required></textarea>
          </label>
          <button type="submit">Send Message</button>
        </form>
      </div>
    </div>
  );
}

export default ContactUs;
